import { render, staticRenderFns } from "./chooseCameraOrImgFrame.vue?vue&type=template&id=2d308130&scoped=true&"
import script from "./chooseCameraOrImgFrame.vue?vue&type=script&lang=js&"
export * from "./chooseCameraOrImgFrame.vue?vue&type=script&lang=js&"
import style0 from "./chooseCameraOrImgFrame.vue?vue&type=style&index=0&id=2d308130&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d308130",
  null
  
)

export default component.exports